export default "__VITE_ASSET__Cx7TL3qN__"